import { Button, Tooltip } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
// import EquipmentListTable from './EquipmentListTable';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import { useAppSelector } from '../../../Reducers/store';
import { HiPlus } from 'react-icons/hi';
import { UserTerritory } from '../../../Models/UserTerritory';
import UserApi from '../../../Api/UserApi';
import UserTerritoryListTable from './UserTerritoryListTable';
import AddUserTerritoryModal from './AddUserTerritoryModal';
// import EquipmentFeatureListTable from './EquipmentFeatureListTable';
// import AddEquipmentFeatureModal from './AddEquipmentFeatureModal';

export default function UserTerritoryList({ userId }: { userId: number }) {
  const { userModel } = useAppSelector((state) => state.user);
  const [userTerritoryListData, setuserTerritoryListData] = useState<
    UserTerritory[]
  >([]);
  const [selectedUserTerritory, setselectedUserTerritory] =
    useState<UserTerritory | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddUserTerritory, setshowAddUserTerritory] =
    useState<boolean>(false);

  const getUserTerritorys = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return UserApi.getUserTerritoryList(userId)
          .then((res) => {
            setuserTerritoryListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    getUserTerritorys();
  }, [getUserTerritorys]);

  const handleAddUserTerritoryClick = () => {
    setselectedUserTerritory(null);
    setshowAddUserTerritory(true);
  };

  const editUserTerritory = (feature: UserTerritory) => {
    setselectedUserTerritory(feature);
    setshowAddUserTerritory(true);
  };

  function deleteUserTerritory(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      UserApi.deleteUserTerritory(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            getUserTerritorys();
          } else {
            toast.success('Error while deleting item');
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
    }
  }
  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        {checkAccess() && (
          <div className='w-full flex justify-end'>
            <Tooltip content={`Add Feature`}>
              <Button
                onClick={handleAddUserTerritoryClick}
                className='buttonMain'
              >
                <HiPlus size={20} />
              </Button>
            </Tooltip>
          </div>
        )}
        <div className='w-full p-4'>
          {isLoading && <Loader />}
          <UserTerritoryListTable
            data={userTerritoryListData}
            deleteUserTerritory={deleteUserTerritory}
            editUserTerritory={editUserTerritory}
          />
        </div>
      </div>
      <AddUserTerritoryModal
        show={showAddUserTerritory}
        setShow={setshowAddUserTerritory}
        userId={userId}
        getUserTerritorys={getUserTerritorys}
        userTerritory={selectedUserTerritory}
      />
    </>
  );
}
